import { SpiderWebIcon } from './SpiderWebIcon';

/**
 * author: Austin Andrews
 * id 8464C75D-EA57-4E89-80E9-BE6A48793809
 * name spider-web
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spider-web.svg
 * tags
 * - Holiday 
 */
export const ArachnidWebIcon = SpiderWebIcon;
export default ArachnidWebIcon